/* src/interviews/components/AddTime/styles.js */

export default theme => {
  const { unit } = theme.spacing;

  return {
    inputContainer: {
      padding: unit * 3,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    textField: {
      marginRight: unit,
      marginBottom: unit * 2,
      width: 150,
    },
    textFieldTime: {
      marginRight: unit,
      marginBottom: unit * 2,
      width: 125,
    },
    title: {
      marginLeft: unit * 2,
      marginTop: unit * 2,
    },
  };
};



// WEBPACK FOOTER //
// ./src/modules/interviews/components/AddTime/styles.js